const STORAGE = window.localStorage;
STORAGE.removeItem("clientListCache");
import moment from 'moment';
import configStore from "./services/ConfigurationService";
import auth from "./auth";

const MONTH_LABELS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export default {
  propToArray: function (props) {
    var result = [];
    for (var k in props) {
      result.push(props[k]);
    }
    return result;
  },
  copyJson: function (json) {
    return JSON.parse(JSON.stringify(json));
  },
  log: function (obj) {
    console.log(JSON.parse(JSON.stringify(obj)));
  },
  offsetDate: function (v) {
    if (v !== null || v !== undefined || v !== "") {
      let d = new Date(v);
      return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
    }
    return v;
  },
  arrayToObj(array, key) {
    return Object.fromEntries([...array.entries()].map(([i, obj]) => [obj[key], obj]));
  },
  async chunkedClientFetch(http, facId) {
    const keyForSingleFac = "single_fac";
    let cache = JSON.parse(STORAGE.getItem("clientListCache"));
    let clients = [];
    if (cache && (cache[facId] || cache[keyForSingleFac])) {
      clients = cache[facId] || cache[keyForSingleFac];
    } else {
      const url = page => `${window.CONFIG.legacy_facade_api}/clients/list/unit/0/page/${page}?sort=firstName&size=30${facId ? `&facIds=${facId}` : ""}`;
      let page = 0;
      let isLastPage = false;

      while (isLastPage === false) {
        const response = await http.get(url(page));
        clients = [...clients, response.body.content];
        isLastPage = response.body.last;
        page += 1;
      }
      clients = clients.flat();
      cache = cache || {};
      cache[facId || keyForSingleFac] = clients;
      try {
        STORAGE.setItem("clientListCache", JSON.stringify(cache));
      } catch (e) {
        console.log(e);
      }
    }

    return clients;
  },
  sortWithFixedLeadingElements: function (array, ...elements) {
    const set = new Set(array);
    elements.forEach(e => set.delete(e));
    return [...elements, ...Array.from(set).sort()];
  },
  // default datepicker shortcuts used across ./Shared/FiltersSection.vue
  datepickerShortcuts() {
    return [
      {
        text: "Last 7 Days",
        onClick(picker) {
          const start = moment().subtract(6, "days").toDate();
          const end = moment().toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last 30 Days",
        onClick(picker) {
          const end = moment().toDate();
          const start = moment().subtract(30, "days").toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last 90 Days",
        onClick(picker) {
          const end = moment().toDate();
          const start = moment().subtract(90, "days").toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last week",
        onClick(picker) {
          const end = moment().weekday(-1).toDate();
          const start = moment().weekday(-7).toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last month",
        onClick(picker) {
          const lastMonth = moment().subtract(1, "months");
          const end = lastMonth.endOf("month").toDate();
          const start = lastMonth.startOf("month").toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last year",
        onClick(picker) {
          const lastYear = moment().subtract(1, "years");
          const end = lastYear.endOf("year").toDate();
          const start = lastYear.startOf("year").toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Current week",
        onClick(picker) {
          const end = moment().weekday(6).toDate();
          const start = moment().weekday(0).toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Current month",
        onClick(picker) {
          const end = moment().toDate();
          const start = moment().startOf("month").toDate();
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Current year",
        onClick(picker) {
          const end = moment().toDate();
          const start = moment().startOf("year").toDate();
          picker.$emit("pick", [start, end]);
        },
      }
    ]
  },
  generateExportDetailsRow() {
    const username = auth.userInfo().username;
    const date = moment().format(configStore.dateFormat());
    const detailsRow = `Report generated by HealthConnex on ${date} by ${username}`
    return [detailsRow];
  },
  createDuration(start, end, scale) {
    let a = new Date(start),
      b = new Date(end);

    switch (scale) {
      case "day":
        a = moment(new Date(start)).startOf('day');
        b = moment(new Date(end)).endOf('day');
        break;
      case "week":
        a = moment(new Date(start)).startOf('week');
        b = moment(new Date(end)).endOf('week');
        break;
      case "month":
        a = moment(new Date(start)).startOf('month');
        b = moment(new Date(end)).endOf('month');
        break;
      case "quarter":
        a = moment(new Date(start)).startOf('quarter');
        b = moment(new Date(end)).endOf('quarter');
        break;
      case "year":
        a = moment(new Date(start)).startOf('year');
        b = moment(new Date(end)).endOf('year');
        break;
    }

    const getDuration = {
      day: (a, b) => moment(a).diff(b, 'days'),
      week: (a, b) => moment(a).diff(b, 'weeks'),
      month: (a, b) => moment(a).diff(b, 'months'),
      quarter: (a, b) => moment(a).diff(b, 'quarters'),
      year: (a, b) => moment(a).diff(b, 'years'),
    };
    const getDategroup = {
      day: (d) => Number(moment(d).format('DDD')),
      week: (d) => Number(moment(d).format('w')),
      month: (d) => Number(moment(d).format('M')),
      quarter: (d) => Number(moment(d).format('Q')),
      year: (d) => Number(moment(d).format('YYYY')),
    };

    return Array(getDuration[scale](b, a) + 1)
      .fill(null)
      .map((_, i) => {
        const newDate =
          scale === "quarter" ? moment(a).add(i, 'Q') : moment(a).add(i, `${scale}s`);
        let year = getDategroup.year(newDate);
        const dategroup = getDategroup[scale](newDate);
        if (scale === "week" && dategroup === 1) {
          // edge case, extract year from *end* of week if its first week of the year
          year = moment(newDate).endOf('week').getFullYear();
        }
        let label = ``;
        switch (scale) {
          case "day":
            label = newDate.format('MM-DD');
            break;
          case "week":
            label = `W${dategroup}-${year}`;
            break;
          case "month":
            label = `${year}-${`${dategroup}`.padStart(2, "0")}`;
            break;
          case "quarter":
            label = `Q${dategroup}-${year}`;
            break;
          case "year":
            label = `${year}`;
            break;
        }
        return {
          year,
          dategroup,
          label,
        };
      });
  }
};
